module.exports = __webpack_public_path__ + "img/activity_11.b49d95a4.png";